import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

export const UnsupportedAssetCircleIcon = (props: SVGProps): JSX.Element => {
  const { title = 'UnsupportedAsset', className, ...restProps } = props;

  return (
    <svg
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('fill-current', className)}
      {...restProps}
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM24 44C34.9411 44 44 34.9411 44 24C44 13.0589 34.9411 4 24 4C13.0589 4 4 13.0589 4 24C4 34.9411 13.0589 44 24 44Z"
      />
      <path d="M12.686 33.3137L33.3137 12.686L35.3137 14.686L14.686 35.3137L12.686 33.3137Z" />
    </svg>
  );
};
